import ImageButton from "./ImageButton";
import styled from "styled-components";
const BackCircle = styled(ImageButton)`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 1%;
  left: 2%;
  margin-right: 10px;
  margin-top: 10px;
  z-index: 12;
`;
export default BackCircle;